import React from 'react';
import { Alert, Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import TaskBoard from './TaskBoard';

export default function WorkCenterPage() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      {location.state?.workflowRetired && <Alert severity="info" sx={{ mb: 2 }} onClose={() => navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: null })}>El antiguo Pipeline se retiró de la navegación. El trabajo se gestiona en Tareas y seguimiento. Sus registros anteriores se conservan, sin convertirlos automáticamente en tareas.</Alert>}
      <TaskBoard />
    </Box>
  );
}
